// extracted by mini-css-extract-plugin
export var privacyNoticeTable = "tableComponent-module--privacyNoticeTable--S7PpX";
export var tableHeadingLeft = "tableComponent-module--tableHeadingLeft--laG7j";
export var tableHeadingRight = "tableComponent-module--tableHeadingRight--u6ogq";
export var tableMainHeading = "tableComponent-module--tableMainHeading--6dAzd";